import axios from "axios"

export interface IngestDestination {
  id: string
  name: string
}

export interface IngestResult {
  status: "success" | "error"
  fileName: string
  destination: string
  error?: string
}

export async function ingestFilesToKnowledgeBases(
  files: File[],
  destinations: IngestDestination[],
  createAsPending = false
): Promise<IngestResult[]> {
  const uploadPromises = files.flatMap((file) => {
    return destinations.map((destination) => {
      const form = new FormData()
      form.append("file", file, file.name)

      return axios
        .post(`/api/km/ingest/document?community_id=${destination.id}&create_as_pending=${createAsPending}`, form)
        .then((response) => ({
          status: "success" as const,
          fileName: file.name,
          destination: destination.name
        }))
        .catch((error) => {
          const errorMessage =
            error.status === 400 && error.response?.detail.includes("already exists")
              ? `Document '${file.name}' already exists in the Knowledge Base '${destination.name}'`
              : `Failed to upload ${file.name} to ${destination.name}`
          return {
            status: "error" as const,
            fileName: file.name,
            destination: destination.name,
            error: errorMessage
          }
        })
    })
  })

  const results = await Promise.allSettled(uploadPromises)
  return results
    .filter((result) => result.status === "fulfilled")
    .map((result) => (result as PromiseFulfilledResult<IngestResult>).value)
}
